import {
  SurveyValidator,
  SurveyValidatorResult
} from 'core/builder/validators/SurveyValidator'

export class SurveyValidatorError extends SurveyValidator {
  result(): Promise<SurveyValidatorResult[]> {
    const result: SurveyValidatorResult[] = []
    this.survey.pages.forEach((page) => {
      const target = page.elements.filter((el) => el.validation !== undefined)
      target.forEach((element) => {
        // Error text is missing
        if (!element.errorText || !element.errorText?.['en']) {
          result.push({
            pageName: page.name,
            elementName: element.name,
            level: 'WARNING',
            description: 'Missing error text for the validation'
          })
        }
      })
    })
    return Promise.resolve(result)
  }
}
